import { Subject } from 'rxjs';

import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SnWidget } from '@lib/api/entities';

@Component({
  selector: 'sn-edit-content-dialog',
  templateUrl: './edit-content-dialog.component.html',
  styleUrls: ['./edit-content-dialog.component.scss'],
})
export class EditContentDialogComponent implements OnInit, OnDestroy {
  public config: any = {
    sanitize: false,
    editable: true,
    toolbarHiddenButtons: [[], ['insertImage', 'insertVideo']],
  };

  private readonly _destroy$ = new Subject<void>();
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SnWidget,
    private readonly _dialogRef: MatDialogRef<EditContentDialogComponent>,
  ) {}

  public ngOnInit(): void {}

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public submitForm(): void {
    this._dialogRef.close(this.data);
  }
}
